import { FC } from 'react';
import { InsightPanelHeader } from './InsightPanelHeader';
import { InsightType } from '../../../types';
import { INSIGHT_PANEL_SIZES } from '../../../constants';
import { CustomInsightPanelHeader } from './CustomInsightPanelHeader';
import { InsightPanelWrapper } from './InsightPanel.styled';

export type InsightPanelProps = {
  title?: string | React.ReactNode;
  className?: string;
  showDivider?: boolean;
  showSelect?: boolean;
  type?: InsightType;
  size?: INSIGHT_PANEL_SIZES;
};

export const INSIGHT_PANEL_DATA_TEST = 'insights-panel';

export const InsightPanel: FC<React.PropsWithChildren<InsightPanelProps>> = ({
  title,
  children,
  className,
  type,
  showDivider,
  showSelect,
  size = INSIGHT_PANEL_SIZES.medium,
}) => {
  /**
   * Separates custom header from normal header as custom has added functionality (like toggle and delete)
   * and would avoid unneeded api calls if using normal
   * */

  const Header = type ? CustomInsightPanelHeader : InsightPanelHeader;
  return (
    <InsightPanelWrapper
      className={className}
      data-test={`${INSIGHT_PANEL_DATA_TEST}${title ? `-${title}` : ''}`}
      data-custom={!!type}
    >
      <Header
        type={type}
        title={title}
        showDivider={showDivider}
        showSelect={showSelect}
        size={size}
      />
      {children}
    </InsightPanelWrapper>
  );
};
